import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Menu } from 'semantic-ui-react';

import AuthModule from './AuthModule';

class Header extends React.Component {
    render() {
        const{ isSignedIn } = this.props;
        return (
            <Menu>
                <Menu.Item header>Admin Pages</Menu.Item>
                <Menu.Item header>
                    <a href="/">Exit</a>
                </Menu.Item>
                { isSignedIn && 
                    <Menu.Item header>
                        <Link to="/admin">Admin</Link>
                    </Menu.Item>
                }
                { isSignedIn && 
                    <Menu.Item header>
                        <Link to="/admin/upload">Upload</Link>
                    </Menu.Item>
                }
                <Menu.Item position="right"> 
                    <AuthModule />
                </Menu.Item>
            </Menu>
        );
    }
}

const mapStateToProps = (state) => {
    return { 
        isSignedIn: state.auth.isSignedIn
    }
}

export default connect(mapStateToProps)(Header);